import { useTranslate } from "ra-core";
import { Badge } from "@/components/ui/badge";
import { ArrowDownLeft, ArrowUpRight, ArrowLeftRight } from "lucide-react";
import type { TransactionDirection } from "../../types";

interface Props {
  direction?: TransactionDirection;
  isTransfer?: boolean;
}

export const TransactionDirectionBadge = ({ direction, isTransfer }: Props) => {
  const translate = useTranslate();
  if (isTransfer) {
    return (
      <Badge variant="outline" className="gap-1">
        <ArrowLeftRight className="h-3 w-3" />
        {translate("resources.transactions.directions.transfer", { _: "Перевод" })}
      </Badge>
    );
  }
  if (!direction) return null;
  const isIncome = direction === "income";
  return (
    <Badge
      variant="outline"
      className={
        isIncome
          ? "border-emerald-300 text-emerald-700 dark:text-emerald-300 gap-1"
          : "border-rose-300 text-rose-700 dark:text-rose-300 gap-1"
      }
    >
      {isIncome ? (
        <ArrowDownLeft className="h-3 w-3" />
      ) : (
        <ArrowUpRight className="h-3 w-3" />
      )}
      {translate(`resources.transactions.directions.${direction}`, {
        _: isIncome ? "Доход" : "Расход",
      })}
    </Badge>
  );
};
